import React from "react";

const PartnerIcon = ({ type, ...rest }) => {
  if (type === 2) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        {...rest}
      >
        <mask
          id="mask0_2895_6189"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="24"
        >
          <rect width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_2895_6189)">
          <path
            d="M4.2115 5.75V4.25H19.7885V5.75H4.2115ZM4.25 19.75V13.75H3.13475V12.25L4.2115 7.25H19.7885L20.8652 12.25V13.75H19.75V19.75H18.25V13.75H13.75V19.75H4.25ZM5.75 18.25H12.25V13.75H5.75V18.25Z"
            fill="#FA1861"
          />
        </g>
      </svg>
    );
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...rest}
    >
      <mask
        id="mask0_2895_6189"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2895_6189)">
        <path
          d="M4.2115 5.75V4.25H19.7885V5.75H4.2115ZM4.25 19.75V13.75H3.13475V12.25L4.2115 7.25H19.7885L20.8652 12.25V13.75H19.75V19.75H18.25V13.75H13.75V19.75H4.25ZM5.75 18.25H12.25V13.75H5.75V18.25Z"
          fill="#212121"
        />
      </g>
    </svg>
  );
};

export default PartnerIcon;
